<script lang="ts">
	import { AspectRatio, type Image } from '$lib/satellite.types';
	import { srcHelper } from '$lib/utils/ArticleHelper';
	import { blurhashToImageCssObject } from '@unpic/placeholder';
	import { decode } from 'js-base64';

	export let classList: string = '';
	export let image: Image[] = [];
	export let alt: string = '';
	export let aspectRatio: AspectRatio = AspectRatio._1BY1;
	export let aspectRatioClass: boolean = true;
	export let blurhash: string = '';
	export let loading: 'lazy' | 'eager' = 'lazy';
	export let fetchpriority: 'auto' | 'high' | 'low' = 'auto';
	export let sizes: string = '100vw';

	let aspectRatioClasses: Record<string, string> = {
		'1by1': 'aspect-[1/1]',
		'4by3': 'aspect-[4/3]',
		'16by9': 'aspect-[16/9]',
		'5by2': 'aspect-[5/2]',
		'2by1': 'aspect-[2/1]'
	};

	const { src, srcset } = srcHelper(image, aspectRatio);

	if (aspectRatioClass) {
		classList += ' ' + aspectRatioClasses[aspectRatio];
	}
	classList += ` bg-gray-100 bg-cover bg-no-repeat`;

	let style: string = '';

	if (blurhash) {
		const decoded = decode(blurhash);
		const obj = blurhashToImageCssObject(decoded);
		style = 'background-image: ' + obj.backgroundImage.replaceAll('"', '') + ';';
	}
</script>

<img {fetchpriority} {src} {alt} {srcset} class={classList} {style} {sizes} {loading} />
